export default __webpack_public_path__ + "static/images/cashback-mail-151d5ee69e408dfd2fab0196629fb821.jpg";